/* 
Pantalla registro compuesta con FormUser parametrizado para registrar.
Response: es una varaible para comunicarse con FormUser.
 */

import React, { useEffect, useState } from "react";

import { GETTOKEN } from '../../constants';

//REDUX
import { useDispatch } from "react-redux";
import { loadingAction, logoutAction } from "../../redux/actions/userActions";

//MODULES
import { FormUser } from "ilusiona-react-components";

//#region CSS
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "10px",
    display: "flex"
  },
  border: {
    boxShadow: "0px 0px 3px 1px #9abf3a",
    paddingTop: "20px",
    paddingBottom: "20px",
    marginTop: "60px",
    marginBottom: "50px"
  },
  form: {
    width: "90%",
    marginTop: theme.spacing(3)
  },
  link: {
    color: "blue"
  },
  disabled: {},
  checkboxError: {
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "red",
    marginTop: "1px"
  }
}));
//#endregion

function Register({ history }) {
  const classes = useStyles();

  const isMobile = useMediaQuery("(max-width:500px)");
  const [response, setResponse] = useState({});

  const dispatch = useDispatch();

  //Es un callback para poder comunicar con Ilusiona-react-component
  //Para saber si el usuario ha sido registado, mail modificado para poder desloguear, cargando o logueado
  useEffect(() => {
    if ("loading" in response) {
      const loading = loading => dispatch(loadingAction(loading));
      loading(response.loading);
    }
    if ("logout" in response) {
      const logout = () => dispatch(logoutAction());
      logout().then(() => {
        history.push("/email-modificado/" + response.logout);
      });
    }
    if ("registered" in response) {
      history.push("/registrado/" + response.registered);
    }
    if ("login" in response) {
      history.push("/login");
    }
  }, [dispatch, history, response]);

  return (
    <div className={classes.root}>
      <FormUser
        setResponse={setResponse}
        token={GETTOKEN()}
        options={{ isRegister: true, isMobile: isMobile }}
      ></FormUser>
    </div>
  );
}

export default Register;
